// extracted by mini-css-extract-plugin
module.exports = {"container":"slider_container__3vo9M","wrapper":"slider_wrapper__3LDeC","innerWrapper":"slider_innerWrapper__2oPm9","btn":"slider_btn__gbhB7","btnImg":"slider_btnImg__2Foes"};